import imageCompression from 'browser-image-compression';

// compresses an uploaded image to a max of 256 x 256. Returns a file and a generated url.
async function compressImage(file) {
  try {
    const compressedFile = await imageCompression(file, {
      maxSizeMB: 1,
      maxWidthOrHeight: 256,
      useWebWorker: true
    });
    const src = URL.createObjectURL(compressedFile);
    // console.log(`originalFile size ${file.size / 1024 / 1024} MB`);
    // console.log(`fileToUpload size ${compressedFile.size / 1024 / 1024} MB`);
    return {
      file: compressedFile,
      src
    }
  } catch (error) {
    // worst case scenerio, we upload an uncompressed image
    console.log(error);
    return {
      file,
      src: URL.createObjectURL(file)
    }
  }
}

export default compressImage